export default {
  clearFilter(api) {
    api.setFilterModel(null);
    api.onFilterChanged();
  }
}